<template>
    <div class="w-full rounded" :class="isFocussed ? 'border border-primary-20' : 'bg-primary-5'">
        <div
            class="w-full px-16 py-8 rounded-t flex flex-wrap cursor-text"
            :class="showFilteredCategories ? ('border-b-2 border-primary-20') :
                (isFocussed ? 'border-primary-20' : '')"
            @click="focusInput">
            <input
                id="category-search-input"
                ref="categorySearch"
                type="search"
                v-model="filterText"
                :placeholder="$t('vdab.search_template')"
                class="flex-1 h-24 placeholder-primary-80 outline-none first-letter:uppercase"
                :class="!isFocussed ? 'bg-primary-5': ''"
                @blur="blurHandle"
                @focus="setFocus"
                @click="setFocus"
                @keydown.up.prevent="highlightPrevious"
                @keydown.down.prevent="highlightNext"
                @keydown.enter.prevent="selectCategory"
                @keydown.escape="resetFilterText"
            >
            <loading v-if="fetchingCategories" class="mr-16" size="small"></loading>
            <svg-icon type="search" class="max-h-16 max-w-16 my-auto ml-16"></svg-icon>
        </div>

        <div
            v-show="showFilteredCategories"
            class="w-full h-200 overflow-y-scroll relative bg-white"
            ref="container">
            <ul class="">
                <li v-for="(category, index) in filteredCategories" :key="category.id" :ref="'category-' + index">
                    <button
                        @mouseover="highlightCategory(index)"
                        @click="selectCategory(category)"
                        class="group px-16 h-40 leading-none flex items-center w-full"
                        data-category="category-option"
                        :class="[ highlightedCategory === index ? 'bg-primary text-white' : '' ]"
                    >
                        <span class="mr-auto">{{ category.name }}</span>
                        <span class="ml-24 font-semibold" :class="[ highlightedCategory === index ? 'inline' : 'hidden' ]">{{ $t('general.select') }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Loading from './Loading.vue';
import * as vdab from '../../services/VdabService';
import SvgIcon from './SvgIcon.vue';
import _debounce from 'lodash/debounce';

export default {
    components: {
        'loading': Loading,
        'svg-icon': SvgIcon,
    },
    props: {
        currentCategory: {
            default: {},
        },
    },
    data: function () {
        return {
            isFocussed: false,
            fetchingCategories: false,
            selectingCategory: false,
            filterText: '',
            highlightedCategory: 0,
            filteredCategories: [],
            category: this.currentCategory,
        }
    },
    computed: {
        query () {
            return this.filterText.trim().toLowerCase();
        },
        showFilteredCategories () {
            return this.isFocussed &&
                !this.fetchingCategories &&
                this.filteredCategories.length > 0;
        },
    },
    methods: {
        blurHandle (evt) {
            if (!evt.relatedTarget ||
                !evt.relatedTarget.getAttribute('data-category')) {
                this.removeFocus();
            }
        },
        setFocus () {
            this.isFocussed = true;
            this.searchCategory();
        },
        removeFocus () {
            this.isFocussed = false;
        },
        resetFilterText () {
            this.filterText = this.category.name;
        },
        selectCategory (category = null) {
            this.selectingCategory = true;
            this.category = (category.type !== 'keydown') ?
                category :
                this.filteredCategories[this.highlightedCategory];

            this.filterText = this.category.name;
            this.highlightedCategory = 0;
            this.$refs.container.scrollTop = 0;
            this.$emit('select', this.category);
            this.removeFocus();
            this.selectingCategory = false;
        },
        highlightCategory (index) {
            this.highlightedCategory = (index != null) ? index : 0;
        },
        highlightPrevious () {
            this.highlightedCategory = (this.highlightedCategory - 1) < 0 ?
                this.filteredCategories.length - 1 :
                this.highlightedCategory - 1;

            this.scrollIntoView();
        },
        highlightNext () {
            this.highlightedCategory = (this.highlightedCategory + 1 ) == this.filteredCategories.length ? 0 : this.highlightedCategory + 1;

            this.scrollIntoView();
        },
        scrollIntoView () {
            let container = this.$refs.container;
            let el = this.$refs['category-' + this.highlightedCategory][0] || this.$refs['category-' + this.highlightedCategory];

            if (el.offsetTop < container.scrollTop) {
                container.scrollTop = el.offsetTop;
            }

            if (el.offsetTop + el.clientHeight > container.clientHeight + container.scrollTop) {
                container.scrollTop = el.offsetTop - (container.clientHeight - el.clientHeight);
            }
        },
        focusInput () {
            this.$refs.categorySearch.focus();
        },
        searchCategory () {
            this.fetchingCategories = true;
            this.filteredCategories = [];

            vdab.indexCategories(this.query).then(result => {
                this.filteredCategories = result;
            }).finally(() => this.fetchingCategories = false);
        }
    },
    watch: {
        filterText: _debounce(function (newText, oldText) {
            if (newText !== this.category.name) {
                this.searchCategory();
            }
        }, 400),
    },
    mounted () {
        if (this.category.hasOwnProperty('name')) {
            this.filterText = this.category.name;
            this.searchCategory();
        }
    },
}
</script>
